import React from "react";
import { node, shape, string } from "prop-types";
import { classes } from "../utils/classes";
import { spacingClassName, spacingPropTypes, spacingProps } from "../props/spacing";
import { sxClassName, sxPropTypes, sxProps } from "../props/sx";
import { utilityClassName, utilityPropTypes, utilityProps } from "../props/utility";

const CardPrice = ({ className = "", children, contentProps = {} }) => {
	const {
		spacing = { ...spacingProps },
		sx = { ...sxProps },
		utility = { ...utilityProps },
	} = contentProps;
	return (
		<div className="card-price">
			<div className={classes("card-price-container", className)}>
				<div
					className={classes(
						"card-price-content",
						...spacingClassName(spacing),
						...sxClassName(sx),
						...utilityClassName(utility),
					)}
				>
					{children}
				</div>
			</div>
		</div>
	);
};

CardPrice.propTypes = {
	className: string,
	children: node.isRequired,
	contentProps: shape({
		utility: utilityPropTypes,
		sx: sxPropTypes,
		spacing: spacingPropTypes,
	}),
};

export default CardPrice;
